import sortByStartDates from "../sort-by-start-dates";

export default function getRecentPeriod(items) {
  // Ensure chronologically ascending sort order.
  sortByStartDates(items);

  const now = new Date();
  return items.reduce((acc, cur) => {
    // Note, the following applies for the time part if these `DateTime`s are not `null` or `undefined`:
    // - `startDate` is always set to 00:00:00.000 (= first day)
    // - `endDate` is always set to 23:59:59.999 (= last day)
    // However:
    // - `frontendDisplayStartDate` is always set to 00:00:00.000 (= first visible day)
    // - `frontendDisplayEndDate` is *also* always set to 00:00:00.000! (= next day, or first invisible day)
    // => The season field `frontend_display_end_date` is used as the table's TYPO3 `endtime`.
    //    Its label is, for clarification, changed to "Invisible starting from (at midnight)".
    //    We do not want editors to have to select 23:59 in a date picker - that would be error prone.

    // Keep only past items.
    if (new Date(cur.endDate) >= now) {
      return acc;
    }

    // Return current item without checking startDate,
    // because we have already sorted all items
    // in chronological order.
    // -> Replace acc by cur until cur does not match any more.
    return cur;
  }, null);
}
